export const BASE_DELAY = 20;
export const BULK_REQUEST_LIMIT = 500;
export const DO_NOT_CARE_STAFF = 'DO_NOT_CARE';
export const MAX_STAFF_FILTER_SELECTIONS = 5;
export const AVAILABILITY_PLUGIN_SLOT_ID = 'calendar-availability-slot';
export const STAFF_RESOURCE_ID = '1cd44cf8-756f-41c3-bd90-3e2ffcaf1155';
export const ANONYMOUS_RESCHEDULE_EXPERIMENT =
  'specs.bookings.AnonymousReschedule';
export const SHOW_STAFF_DROPDOWN_SINGLE_SLOT_EXPERIMENT =
  'specs.bookings.showStaffDropdownWhenSingleStaffOnSlot';
export const ALL_DAY_MULTI_DAY_EXPERIMENT =
  'specs.bookings.AllDayMultiDayEvents';
export const FILTER_STAFF_BY_LOCATION_EXPERIMENT =
  'specs.bookings.filterCalendarStaffByLocation';
